export const FEATURE_NAME = '@zerops/zerops/core/user-data-base';

export const FORBIDDEN_USER_DATA = [ 'nginxConfig' ];
